export default {
    namespaced: true,
    state: () => ({
        list: {}
    }),
    mutations: {
        set (state, obj) {
            state.list[obj.key] = obj.state;
        }
    },
    actions: {
        set({ commit }, obj) {
            commit('set', obj);
        }
    }
}